import { forwardRef, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link, LinkProps, useLocation } from 'react-router-dom'

import {
  Icon,
  IconProps,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemTextProps,
  Tooltip,
  Badge,
} from '@mui/material'

interface ListItemLinkProps {
  IconProps: IconProps
  ItemTextProps?: ListItemTextProps
  text: string
  to: string
  format?: boolean
  badgeContent?: number
}

export function ListItemLink({
  text,
  to,
  IconProps,
  ItemTextProps,
  format = false,
  badgeContent,
}: ListItemLinkProps) {
  const { pathname } = useLocation()
  const isActive = pathname === to || pathname.startsWith(to + '/')

  const renderLink = useMemo(
    () =>
      forwardRef<any, Omit<LinkProps, 'to'>>((itemProps, ref) => (
        <Link to={to} ref={ref} {...itemProps} />
      )),
    [to],
  )

  return (
    <Tooltip placement="right" title={text}>
      <ListItem
        button
        component={renderLink}
        sx={{ color: '#fff', position: 'relative' }}
      >
        <ListItemIcon style={{ minWidth: 40 }}>
          <Icon
            {...IconProps}
            fontSize={isActive ? 'medium' : 'small'}
            sx={{
              color: isActive ? '#2ecc71' : '#fff',
              paddingRight: '28px',
              transition: 'color 0.2s, font-size 0.2s',
            }}
          />
        </ListItemIcon>
        <ListItemText
          {...ItemTextProps}
          primary={format ? <FormattedMessage id={text} /> : text}
        />

        {badgeContent && (
          <Badge
            badgeContent={badgeContent}
            color="error"
            sx={{
              position: 'absolute',
              top: 12,
              right: 15,
            }}
          />
        )}
      </ListItem>
    </Tooltip>
  )
}
